import React from 'react'

import { ReasonsWhyProps } from './types'
import {
  ReasonsWhyStyled,
  ReasonsWhyActionStyled,
  ReasonsWhyContentStyled,
  ReasonsWhyMediaStyled,
  ReasonsWhyListStyled,
  ReasonsWhyListItemStyled,
  ReasonsWhyIconStyled,
  ReasonsWhyLabelStyled,
  ReasonsWhyBoxStyled,
  ReasonsWhyBoxInfoStyled,
  ReasonsWhyBoxLabelStyled,
  ReasonsWhyMediaLeftStyled,
  ReasonsWhyMediaRightStyled,
  ReasonsWhyArrowStyled
} from './styles'
import Button from '../../atoms/Button'
import { IconSpecs, IconArrowPointerLeft, IconArrowPointerRight } from '../../../assets/svg'

const ReasonsWhy: React.FC<ReasonsWhyProps> = ({ data: { cta, listItems, specification } }) => (
  <ReasonsWhyStyled>
    <ReasonsWhyContentStyled>
      {specification && (
        <ReasonsWhyMediaStyled>
          <ReasonsWhyMediaLeftStyled />
          <ReasonsWhyBoxStyled>
            <IconSpecs />
            {specification.specificationLabel && (
              <ReasonsWhyBoxLabelStyled as="p" variant="headingMontserrat4">
                {specification.specificationLabel}
              </ReasonsWhyBoxLabelStyled>
            )}
            {specification.specificationInfo && (
              <ReasonsWhyBoxInfoStyled
                as="p"
                variant="bodyMontserrat8"
                dangerouslySetInnerHTML={{ __html: specification.specificationInfo }}
              />
            )}
          </ReasonsWhyBoxStyled>
          <ReasonsWhyMediaRightStyled />
        </ReasonsWhyMediaStyled>
      )}
      {listItems && (
        <ReasonsWhyListStyled>
          {listItems.map((el, index) => (
            <ReasonsWhyListItemStyled key={el.key}>
              <ReasonsWhyIconStyled />
              <ReasonsWhyLabelStyled as="p" variant="bodyMontserrat10">
                {el.label}
                <ReasonsWhyArrowStyled>{index % 2 ? <IconArrowPointerRight /> : <IconArrowPointerLeft />}</ReasonsWhyArrowStyled>
              </ReasonsWhyLabelStyled>
            </ReasonsWhyListItemStyled>
          ))}
        </ReasonsWhyListStyled>
      )}
    </ReasonsWhyContentStyled>
    {cta && cta.urlText && (
      <ReasonsWhyActionStyled>
        <Button variant="withArrow" {...cta} />
        {/* {cta.caption && (
          <Text
            sx={{
              variant: 'bodyMontserrat7',
              fontFamily: 'primary',
              marginTop: '5px'
            }}
          >
            {cta.caption}
          </Text>
        )} */}
      </ReasonsWhyActionStyled>
    )}
  </ReasonsWhyStyled>
)

export default ReasonsWhy
